<template>
  <div
    class="input-group__error"
    v-if="invalid"
    role="alert"
    v-html="message"
  />
</template>

<script>
export default {
  name: "error",
  props: { invalid: Boolean, message: { type: String, default: "Error" } },
};
</script>

<style></style>
